import { select, svg } from 'd3'
import moment from 'moment'
import { FC, SVGProps, useEffect, useRef } from 'react'
import { UseChartContext } from 'components/atoms/chart/useChart'

type ChartBottomAxisProps =
  & SVGProps<SVGGElement>
  & {
    context: UseChartContext
  }

export const ChartBottomAxis: FC<ChartBottomAxisProps> = (props) => {
  const { context, ...restProps } = props

  const gRef = useRef<SVGGElement>(null)

  useEffect(() => {
    const { current } = gRef
    if (!current) {
      return
    }

    const axisGenerator = svg.axis()
      .orient('bottom')
      .scale(context.scaleX)
      .tickValues(context.xArray)
      .tickSize(6)
      .tickFormat((item) => moment(item).format('MMM'))

    axisGenerator(select(current))
  }, [context.scaleX, context.xArray])

  return (
    <g ref={ gRef } { ...restProps } />
  )
}
